<template>
    <div class="user_login_wrap">
        <div class="title pt0">
            <h2>로그인</h2>
        </div>
        <form @submit.prevent="fn_click_login">                
            <div class="form">
                <input type="text" ref="loginId" class="login_form" v-model="loginInfo.loginId" autocomplete="username" placeholder="입력해주세요" @keyup.enter="focusNext('loginPw')">
                <input type="password" ref="loginPw" class="login_form" v-model="loginInfo.loginPw" autocomplete="current-password" placeholder="입력해주세요" @keyup.enter="fn_click_login">
            </div>
            <button class="login_btn" type="submit" :disabled="isSubmitting" >로그인</button>
        </form>
        <div class="find_box">
            ※ 아이디 / 비밀번호 찾기 / 회원탈퇴는 고객센터로 연락주시기 바랍니다.
            <!-- <router-link to="/">아이디찾기</router-link>
            <router-link to="/">비밀번호찾기</router-link> -->
        </div>
        <div class="join_txt">
            <p>아직 계정이 없으신가요? <router-link to="/userJoin">회원가입</router-link></p>
        </div>
        <alert-modal 
        :id="'alert'"
        :text="showAlertMsg" 
        :btnRight="'확인'" 
        :oneBtn="false"
        :isShow="showAlert"
        :className="'btn_brown'"
        v-on:update:showSetting="fn_showSet"
    />
    </div>
</template>

<script>
    import axios from 'axios'
    import AlertModal from "@/modal/common/alertModal.vue"
    import alertutill from "@/mixin/alertModalUtill";

    export default {
        name: 'UserLogin',
        components: {
            'alert-modal' : AlertModal,
            //'confirm-modal': AlertModal,
        },
        mixins: [alertutill],
        data() {
            return {
                loginInfo : {
                    id : '',
                    loginPw : '',
                },
                isSubmitting: false,
            }
        },
        methods : {
            fn_click_login(){

                if(this.loginInfo.loginId == null || this.loginInfo.loginId == ''){
                    let msg = "아이디를 입력해주세요";
                    this.fn_open_alert(msg); 

                    this.isSubmitting = false;
                    return;
                }

                this.isSubmitting = true;

                axios
                    .post("/api/user/login/doctorLogin", this.loginInfo)
                    .then((res) => {                            
                        console.log("@@@@ res data : %o",res.data);

                        if(res.data.result == 'ok'){
                           
                           console.log("@@@@ login ok");

                           //로그인 정보 셋팅
                            this.$store.dispatch('clinicDoctorInfo/setDoctorNm', res.data.loginInfo.doctor_nm);
                            this.$store.dispatch('clinicDoctorInfo/setClinicDoctorId', res.data.loginInfo.clinic_doctor_id);
                            this.$store.dispatch('clinicDoctorInfo/setLoginId', res.data.loginInfo.login_id);
                            this.$store.dispatch('clinicDoctorInfo/setClinicDoctorClass', res.data.loginInfo.clinic_doctor_class);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorGender', res.data.loginInfo.doctor_gender);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorBirthYear', res.data.loginInfo.doctor_birth_year);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorBirthMonth', res.data.loginInfo.doctor_birth_month);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorBirthDay', res.data.loginInfo.doctor_birth_day);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorPostNo', res.data.loginInfo.doctor_post_no);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorAddr', res.data.loginInfo.doctor_addr);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorAddrDtl', res.data.loginInfo.doctor_addr_dtl);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorPhoneNum', res.data.loginInfo.doctor_phone_num);
                            this.$store.dispatch('clinicDoctorInfo/setdoctorTelNum', res.data.loginInfo.doctor_tel_num);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorEmail', res.data.loginInfo.doctor_email);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorLicenseNum', res.data.loginInfo.doctor_license_num);
                            this.$store.dispatch('clinicDoctorInfo/setLicenseIssuanceDate', res.data.loginInfo.license_issuance_date);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorEmailRecvYn', res.data.loginInfo.doctor_email_recv_yn);
                            this.$store.dispatch('clinicDoctorInfo/setDoctorPhoneRecvYn', res.data.loginInfo.doctor_phone_recv_yn);
                            this.$store.dispatch('clinicDoctorInfo/setApprovalYn', res.data.loginInfo.approval_yn);
                            this.$store.dispatch('clinicDoctorInfo/setNickNm', res.data.loginInfo.nick_nm);
            
                            if(res.data.loginInfo.clinic_doctor_class == 'C'){
                                this.$store.dispatch('clinicDoctorInfo/setClinicNm', res.data.loginInfo.clinic_nm);   
                                this.$store.dispatch('clinicDoctorInfo/setClinicPostNo', res.data.loginInfo.clinic_post_no);  
                                this.$store.dispatch('clinicDoctorInfo/setClinicAddr', res.data.loginInfo.clinic_addr);
                                this.$store.dispatch('clinicDoctorInfo/setClinicAddrDtl', res.data.loginInfo.clinic_addr_dtl);
                                this.$store.dispatch('clinicDoctorInfo/setClinicBusinessNum', res.data.loginInfo.clinic_business_num); 
                                this.$store.dispatch('clinicDoctorInfo/setClinicTelNum', res.data.loginInfo.clinic_tel_num); 
                                
                            }

                            this.$router.push({ name: 'Main'}); 

                        }else{                                
                            let msg = "잘못된 아이디,패스워드입니다";
                            this.fn_open_alert(msg); 
                            this.isSubmitting = false;                                
                        }
                        
                    })
                    .catch((err) => console.log(err));
            },
            focusNext(refName) {
                // v-if 등으로 아직 렌더 안 된 경우 대비
                this.$nextTick(() => {
                    const ref = this.$refs[refName]
                    const el = Array.isArray(ref) ? ref[0] : ref
                    if (el && el.focus) el.focus()
                })
            },
        }
    }
</script>